import axios from 'axios'
import {MessageBox, Message} from 'element-ui'

const apiroot = "https://api.cnaiiot.com"
//const apiroot = "https://test.cnaiiot.com"
const Axios = axios.create({
    baseURL: apiroot,
    timeout: 100000,
})
Axios.interceptors.request.use(config => {
        return config
    },
    error => {
        return Promise.reject(error)
    })

Axios.interceptors.response.use(response => {
        const res = response.data;
        if (res.code !== '00000' && (res != 0 || res != '0')) {
            Message({
                message: `${res.message || '网络错误'}`,
                type: 'error',
                duration: 1000,
                showClose: true
            })
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 1000,
            showClose: true
        })
        return Promise.reject(error)
    })

export default Axios